import { differenceInDays, isPast } from 'date-fns';
import type { Nullable } from '@gov-nx/core/types';
import { isString } from '@gov-nx/core/types';
import { today } from './utils';

export const isInPastOrNearFuture = (
	input?: Nullable<Date> | string,
	daysLimit = 90
): boolean => {
	if (!input) return false;
	const date = isString(input) ? today(input) : input;
	const now = today();

	return isPast(date) || differenceInDays(date, now) < daysLimit;
};
